import React from 'react';
import {
  Switch as MUISwitch,
  SwitchProps as MUISwitchProps,
  FormControlLabel as MUIFormControlLabel,
  FormControlLabelProps as MUIFormControlLabelProps,
} from '@mui/material';

export type ToggleSwitchProps = Omit<MUISwitchProps, 'onChange'> & {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  LabelProps?: MUIFormControlLabelProps;
  offColor?: string;
};

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, label, LabelProps, offColor, ...props }) => {
  const handleChange = React.useCallback((_: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
    onChange(value);
  }, [ onChange ]);

  const offColorSx = offColor && !checked ? {
    '& .MuiSwitch-track': { backgroundColor: `${offColor} !important`, opacity: 0.5 },
    '& .MuiSwitch-thumb': { backgroundColor: offColor },
  } : undefined;

  return (
    <MUIFormControlLabel
      {...LabelProps}
      label={label}
      control={(
        <MUISwitch
          {...props}
          checked={checked}
          onChange={handleChange}
          sx={offColorSx}
        />
      )}
    />
  );
};
